import { useTheme } from '@opallabs/hooks'
import { Button } from '../../Button'
import * as styles from '../styles'
import { useCalendar } from '../useCalendar'

export const DateRemover: React.FC = () => {
  const theme = useTheme()
  const calendar = useCalendar()

  function handleRemoveDate() {
    calendar.selectDate(null)
  }

  const isDisabled = !calendar.selectedDate

  return (
    <Button
      name="Remove Date"
      disabled={isDisabled}
      onClick={handleRemoveDate}
      variant="tertiary"
      buttonText="Remove Date"
      styleOverrides={{
        button: styles.removeDate({ theme }),
        text: styles.disabledText(isDisabled),
      }}
    />
  )
}
DateRemover.displayName = 'Lapidary: DateRemover ← Calendar'
